const Panel = (props) => {
  const mainCss = `card bg-panel rounded-4 ${props.mainCss}`;
  return (
    <>
      <div className={mainCss} style={{ backgroundColor: "#FFFFFF", border: "#F8F9FA" }}>
        <div className="p-3 mt-0">
          {props.title && (
            <div className="d-flex pt-3 justify-content-between">
              <div>
                <h4 className="">{props.title}</h4>
              </div>
              <div>
                {props.buttonPlanilha}
                {props.button}
                {props.modal}
              </div>
            </div>
          )}
          {/* Conteúdo passado como filhos (children) */}
          {props.children}
        </div>
      </div>
    </>
  );
};

export default Panel;
